module.exports = __webpack_public_path__ + "static/img/shouchishenfenzheng@2x.f370b1ce.png";